import React from 'react';

const TechnicalManual = () => {
  return (
    <div className="help-section">
      <div className="section-header">
        <div className="icon">🏗️</div>
        <h2>Technical Architecture</h2>
      </div>
      
      <div className="section-grid">
        <div className="info-card">
          <h3>Frontend Stack</h3>
          <ul style={{ color: 'var(--text-secondary)', paddingLeft: '20px' }}>
            <li>React.js with React Router</li>
            <li>Ethers.js v6 for blockchain</li>
            <li>CSS3 with custom design system</li>
            <li>Font Awesome icons</li>
          </ul>
        </div>
        
        <div className="info-card">
          <h3>Backend Stack</h3>
          <ul style={{ color: 'var(--text-secondary)', paddingLeft: '20px' }}>
            <li>Node.js/Express API</li>
            <li>MySQL database</li>
            <li>JWT authentication</li>
            <li>Brave API for Zearch</li>
          </ul>
        </div>
        
        <div className="info-card">
          <h3>ENS Contract</h3>
          <ul style={{ color: 'var(--text-secondary)', paddingLeft: '20px' }}>
            <li>Address: 0x40B4d1d8bCBf4eE89005adF2c48503C53210D26C</li>
            <li>Root Node: zpost.eth</li>
            <li>Method: mintSubdomain(string label)</li>
            <li>Network: Ethereum Mainnet</li>
          </ul>
        </div>
        
        <div className="info-card">
          <h3>Zearch Integration</h3>
          <ul style={{ color: 'var(--text-secondary)', paddingLeft: '20px' }}>
            <li>Powered by Brave Search API</li>
            <li>Privacy-focused results</li>
            <li>Integrated into posting wall</li>
            <li>Web3-native search</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TechnicalManual;
